module.exports = __webpack_public_path__ + "img/samruq.ae31363c.svg";